var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbPixel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "20 -70 2000 660",
    width: 170,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v515h-2048z",
    fill: "#3B5B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(152,131)",
    d: "m0 0h229l8 5 1 2v233l-7 6-4 1h-65l-1-1-1-7v-87l1-1 31-1 5-35h-36v-34l4-6 7-3 11-1h16l-1-31-6-1h-32l-10 3-10 6-8 8-6 12-2 9-1 37-1 1-31 1v34l32 1v95l-1 1h-121l-8-3-3-5-1-4v-226l3-5z",
    fill: "#FEFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,191)",
    d: "m0 0h9v42l15-3h14l13 4 7 5 4 8 1 8v38l-3 14-8 9-10 5-15 3h-19l-26-4-1-3v-121l2-2z",
    fill: "#FEFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,230)",
    d: "m0 0h14l16 4 10 7 5 7 3 12v34l-2 9-6 9-7 6-9 4-11 2h-14l-12-3-10-5-7-8-4-13-1-13v-15l2-14 5-9 9-8 12-5z",
    fill: "#FEFFFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,230)",
    d: "m0 0h14l13 3 8 4 5 5 4 5 3 7 1 8v28l-2 12-4 8-7 7-8 4-14 3h-14l-12-3-10-5-6-7-3-6-2-9-1-9v-15l2-17 6-11 11-8z",
    fill: "#FEFFFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,190)",
    d: "m0 0 4 1v76l-1 2 5-5 18-27 4-5h30l-5 10-16 24-5 9 2 6 12 20 11 17v4h-29l-9-12-8-14-7-11-1-1-1 37-1 1-14 1h-11l-2-1v-127l12-3z",
    fill: "#FEFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1836,187)",
    d: "m0 0 6 2 10 7 44 29 12 8 22 15 1 2v29l-11 8-23 15-44 29-13 9-4 1-1-35 7-6 15-9 15-10 22-14 5-2-3-3-16-10-26-17-17-11-1-1z",
    fill: "#FEFFFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1724,187)",
    d: "m0 0h2l1 15-1 21-10 7-19 12-17 11-16 10 3 3 15 10 16 10 20 13 8 6 1 11-1 26-7-4-10-7-16-10-43-29-11-7-7-6-1-27 3-5 10-7 44-29 28-19z",
    fill: "#FEFFFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(743,230)",
    d: "m0 0h15l15 4 8 5 6 7 3 9v29l-1 1-46 1-4 2 4 9 4 2h22l19-1v21l-9 3-15 2h-22l-12-4-8-5-6-7-4-10-1-6v-32l2-10 5-8 7-6 12-5z",
    fill: "#FEFFFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,232)",
    d: "m0 0h37l14 3 7 5 5 9 1 5v68l-10 1h-10l-4-1-2-3-12 4-7 1h-13l-10-5-6-7-3-8v-17l4-8 6-5 7-2 31-2-2-12-7-2-29-1-1-2 2-20z",
    fill: "#FEFFFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1231,209)",
    d: "m0 0h32l14 4 9 7 5 8 2 6v16l-4 11-6 8-10 6-11 3-24 1v43l-6 2h-8l-1-1v-112z",
    fill: "#FEFFFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(519,188)",
    d: "m0 0h26l3 1v22l-19 2-1 7v11l18 1 1 1v15l-2 7-17 1-1 66-11 1h-15l-2-1-1-67h-12l-1-1v-20l4-2h9l1-25 5-10 7-6z",
    fill: "#FEFFFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1802,169)",
    d: "m0 0h21l1 3-24 73-14 41-20 61-4 10-2 2h-21l-1-3 44-132 13-40 5-13z",
    fill: "#FEFFFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,231)",
    d: "m0 0h28l12 3 1 1v21h-8l-7-1h-18l-6 3-1 2v34l3 4 4 1h18l15-1v21l-2 2-17 3h-19l-13-4-9-6-6-8-3-9-1-7v-28l3-11 5-8 8-7 9-4z",
    fill: "#FEFFFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1451,240)",
    d: "m0 0h15l11 4 9 8 6 13 1 5v14l-1 1-19 1h-39l4 12 4 6 8 7 8 2h11l10-2 7-1 2 4v5l-4 3-11 3-14 1-11-2-9-4-8-6-6-9-3-9-1-6v-14l3-12 6-11 9-8z",
    fill: "#FEFFFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1341,241)",
    d: "m0 0 15 1 7 8 12 18 1 2h2l10-16 8-11 6-2h10l-1 5-11 15-13 19 1 4 15 22 11 16-1 2-15-1-7-8-14-22-2-1-2 5-16 24-3 3h-12l-2-1 2-5 14-20 11-16-4-7-12-17-10-15z",
    fill: "#FEFFFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1514,203)",
    d: "m0 0h11l1 1 1 26v62l-1 31-5 1h-7l-2-1-1-119z",
    fill: "#FEFFFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,220)",
    d: "m0 0h16l9 3 7 5 3 6 1 12-3 9-6 7-8 4-4 1h-17l-3-2v-43z",
    fill: "#3B5B9F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1310,242)",
    d: "m0 0h14l1 1v79l-6 2h-7l-2-1z",
    fill: "#FEFFFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,254)",
    d: "m0 0 9 1 5 5 1 3v25l-2 7-5 4-3 1h-15l-1-5v-34l1-4z",
    fill: "#3B5B9F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(927,254)",
    d: "m0 0h8l6 4 2 3 1 5v24l-3 7-6 3h-8l-6-3-3-6v-28l3-6z",
    fill: "#3B5B9F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,254)",
    d: "m0 0 10 1 4 4 2 9v20l-2 7-5 4-2 1h-8l-6-3-3-5v-29l2-5z",
    fill: "#3B5B9F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1453,250)",
    d: "m0 0h10l8 4 6 9 2 7-1 5h-42l-1-3 3-9 7-9z",
    fill: "#3B5B9F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,252)",
    d: "m0 0h10l5 5 2 5-1 4-18 1-5-2 1-7 4-5z",
    fill: "#3B5B9F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1315,210)",
    d: "m0 0 7 1 4 4v8l-6 4h-7l-5-6 1-6 4-4z",
    fill: "#FEFFFE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,290)",
    d: "m0 0h10l4 4-2 5-4 3-3 1h-8l-5-5 1-5z",
    fill: "#3B5B9F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbPixel);
export default __webpack_public_path__ + "static/media/fb_pixel.79690cf444e019f564ddaf22f9e0eb57.svg";
export { ForwardRef as ReactComponent };